<template>
  <v-app>
    <Age />
    <v-app-bar app color="primary" dark>
      <div class="d-flex align-center">
        <v-icon>mdi-cannabis</v-icon>
        <span>Strain Journal</span>
      </div>
      <v-spacer></v-spacer>
      
      <v-btn text @click="aboutTab = !aboutTab"><template v-if="!aboutTab">
        <span>About</span>
      </template>
          <template v-else>
           <span>Hide About</span>
        </template></v-btn>
    </v-app-bar>

    <v-main>
      <v-container v-if="aboutTab" class="pb-0">
        <v-alert outlined class="mb-0" type="info">I keep a weed journal and wanted to make it available on the internet. You can add your own findings by clicking the <v-icon small>mdi-plus-circle</v-icon> icon below.</v-alert>
      </v-container>

      <Feed />
    </v-main>
  </v-app>
</template>

<script>
import Feed from "./components/Feed";
import Age from "./components/Age";

export default {
  name: "App",

  components: {
    Feed,
    Age
  },

  data: () => ({
    aboutTab: false
  }),
};
</script>
